import React, { useCallback, useEffect, useState } from 'react';
import { adminAPI } from '../../services/api';
import { parseServerDate } from '../../utils/serverDate';
import './Admin.css';

const LIMIT = 50;

const detailsText = (details) => {
  if (details === null || details === undefined || details === '') return '—';
  if (typeof details === 'string') return details;
  try { return JSON.stringify(details); } catch { return String(details); }
};

function AdminAuditLog() {
  const [events, setEvents] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [admin, setAdmin] = useState('');
  const [target, setTarget] = useState('');
  const [action, setAction] = useState('');
  const [applied, setApplied] = useState({ admin: '', target: '', action: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const params = { page, limit: LIMIT };
      if (/^\d+$/.test(applied.admin)) params.admin = applied.admin;
      if (/^\d+$/.test(applied.target)) params.target = applied.target;
      if (applied.action.trim()) params.action = applied.action.trim();
      const res = await adminAPI.getAuditLog(params);
      setEvents(res.data?.events || []);
      setTotal(res.data?.total || 0);
    } catch (err) {
      setError(err?.response?.data?.error || err.message || 'Failed to load audit log');
      setEvents([]);
    } finally {
      setLoading(false);
    }
  }, [page, applied]);

  useEffect(() => { load(); }, [load]);

  const applyFilters = (e) => {
    e.preventDefault();
    setPage(1);
    setApplied({ admin, target, action });
  };

  const pages = Math.max(1, Math.ceil(total / LIMIT));

  return (
    <div className="admin-page">
      <h1>Audit log</h1>

      <form className="admin-controls" onSubmit={applyFilters} style={{ marginBottom: 12, flexWrap: 'wrap' }}>
        <input
          className="form-input"
          style={{ width: 130 }}
          placeholder="Admin user id"
          value={admin}
          onChange={(e) => setAdmin(e.target.value)}
        />
        <input
          className="form-input"
          style={{ width: 130 }}
          placeholder="Target user id"
          value={target}
          onChange={(e) => setTarget(e.target.value)}
        />
        <input
          className="form-input"
          style={{ width: 180 }}
          placeholder="Action (e.g. view_as_start)"
          value={action}
          onChange={(e) => setAction(e.target.value)}
        />
        <button type="submit" disabled={loading}>Filter</button>
      </form>

      {error && <div className="admin-error">{error}</div>}

      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>When</th><th>Admin</th><th>Action</th><th>Target</th><th>Details</th><th>IP</th>
            </tr>
          </thead>
          <tbody>
            {events.map((ev) => (
              <tr key={ev.id}>
                <td>{parseServerDate(ev.created_at)?.toLocaleString() || '—'}</td>
                <td>{ev.admin_user_id ?? '—'}</td>
                <td><span className="admin-pill admin-pill-purple">{ev.action}</span></td>
                <td>{ev.target_user_id ?? '—'}</td>
                <td style={{ whiteSpace: 'normal', maxWidth: 360, wordBreak: 'break-word' }}>{detailsText(ev.details)}</td>
                <td>{ev.ip || '—'}</td>
              </tr>
            ))}
            {events.length === 0 && !loading && (
              <tr><td colSpan={6} className="admin-empty">No events found</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="admin-pagination">
        <button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page <= 1 || loading}>Prev</button>
        <span>Page {page} of {pages} ({total} events)</span>
        <button onClick={() => setPage((p) => p + 1)} disabled={page >= pages || loading}>Next</button>
      </div>
    </div>
  );
}

export default AdminAuditLog;
